export function fromObjectToArray(obj: Object) {
	return Object.keys(obj).map((key) => 
		(obj as any)[key]
	);
}
